import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ObservationDetail } from '../pages/detail';
import { ObservationList } from "../pages/list";
export const ObservationRoutes = () => {
    const { path } = useRouteMatch();
    return (

        <Switch>
            <Route exact path={path} component={ObservationList} />
            <Route path={`${path}/:id`} component={ObservationDetail} />
        </Switch>
    )
}